import { useEffect, useState } from "react";
import styles from "./TwoFactor.module.scss";
import { useHistory } from "react-router";
import { CopyWithInputID } from "../../../../../helpers/CopyToClipboard";
import ReactCodeInput from "react-verification-code-input";
import { errorMessage, successMessage } from "../../../../../utils/messages";
//Icons
import ArrowBackIcon from "../../../../../styles/icon/arrow_back_fill.svg";
import GooglePlayIcon from "../../../../../styles/pics/GooglePlay.svg";
import AppStoreIcon from "../../../../../styles/pics/AppStore.svg";
import CopyIcon from "../../../../../styles/icon/CopyIconGreen.svg";
import QRCodeMaker from "../../../../../utils/QRCodeMaker";
import {
  usersCheckTwoFacCode,
  usersCreateTwoFacCode,
} from "../../../../../services/userServices";
import { useDispatch, useSelector } from "react-redux";
import { userProfile } from "../../../../../actions/user";

export function DownloadGoogleAuth() {
  return (
    <section className={styles.download_google_auth_container}>
      <div className={styles.title}>دانلود اپلیکیشن</div>
      <div className={styles.desc}>
        اپلیکیشن Google Authenticator را دانلود کنید.
      </div>
      <main className={styles.main_of_download_google_auth}>
        <div>دانلود از</div>
        <div>
          <img
            src={GooglePlayIcon}
            alt="Android-GooglePlay"
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US"
              )
            }
          />
        </div>
        <div>
          <img
            src={AppStoreIcon}
            alt="IOS-AppStore"
            onClick={() =>
              window.open(
                "https://apps.apple.com/us/app/google-authenticator/id388497605"
              )
            }
          />
        </div>
      </main>
    </section>
  );
}
export function AppAuthCode({ twoFaCode }) {
  return (
    <section className={styles.download_google_auth_container}>
      <div className={styles.title}>کد را اسکن کنید</div>
      <div className={styles.desc}>
        این QRکد را در اپلیکیشن Google Authenticator یا اپلیکیشن های مشابه اسکن
        کنید.
      </div>
      <main className={styles.main_of_app_auth_code}>
        <div className={styles.QR_container}>
          <QRCodeMaker address={twoFaCode?.url ?? "Reload-APP"} />
        </div>
        <div className={styles.text_one}>
          و یا کد زیر را کپی کنید و در اپلیکیشن Google Authenticator وارد کنید
          تا کد مورد نظر برای ارزفی را تولید کنید
        </div>
        <div className={styles.input_of_QR}>
          <input
            type="text"
            readOnly
            value={twoFaCode.code}
            id="ValueOfInputAppAuthCode"
          />
          <div className={styles.copyIcon}>
            <img
              src={CopyIcon}
              alt="COPY"
              width={25}
              height={25}
              onClick={() => CopyWithInputID("ValueOfInputAppAuthCode")}
            />
          </div>
        </div>
        <div className={styles.text_two}>
          <div>کد بالا را حتما در جایی یادداشت کنید.</div>
          <div>
            اگر موبایلتان گم شد با این کد میتوانید Google Authenticator خود را
            بازیابی کنید.
          </div>
        </div>
      </main>
    </section>
  );
}
export function TakeAuthCodeFromUser({ history }) {
  const [gaCodeDetails, setGaCodeDetails] = useState({
    token: "",
    deactivatedBtn: false,
  });
  const handleCheckGaCode = async (e) => {
    e.preventDefault();
    if (gaCodeDetails.token.length < 6) return;
    setGaCodeDetails({ ...gaCodeDetails, deactivatedBtn: true });
    try {
      const { token } = gaCodeDetails;
      const body = { token };
      const data = await usersCheckTwoFacCode(body);
      if (data.data.error) {
        errorMessage(data.data.message);
      } else {
        successMessage(data.data.message);
        history.replace("/my-profile/info");
      }
    } catch (ex) {
      setGaCodeDetails({ ...gaCodeDetails, deactivatedBtn: false });
    }
  };
  return (
    <section className={styles.download_google_auth_container}>
      <div className={styles.title}>کد را وارد کنید</div>
      <div className={styles.desc}>
        کد ۶ رقمی تولید شده برای ارزفی در اپلیکیشن Google Authenticator را وارد
        کنید
      </div>
      <main className={styles.main_of_verify_2fa_code}>
        <form onSubmit={(e) => handleCheckGaCode(e)}>
          <div className={styles.input_confirm_code}>
            <ReactCodeInput
              fields={6}
              className={styles.input_places}
              fieldWidth={43}
              fieldHeight={43}
              placeholder={["-", "-", "-", "-", "-", "-", "-", "-"]}
              autoFocus={true}
              onComplete={(e) =>
                setGaCodeDetails({ ...gaCodeDetails, token: e })
              }
            />
          </div>
          <button type="submit" disabled={gaCodeDetails.deactivatedBtn}>
            تایید
          </button>
        </form>
      </main>
    </section>
  );
}
export default function TwoFactor() {
  const { replace } = useHistory();
  const [step2fa, setStep2fa] = useState("1");
  const history = useHistory();
  //
  const userInfo = useSelector((state) => state.fullUserInfo.data_profile);
  const dispatch = useDispatch();
  const [twoFaCode, setTwoFaCode] = useState("");

  useEffect(() => {
    const getTwoFacCode = async () => {
      const data = await usersCreateTwoFacCode();
      if (data.data.message) setTwoFaCode(data.data.secret);
    };
    getTwoFacCode();
    if (!userInfo) dispatch(userProfile());
  }, []);

  return (
    <>
      {!userInfo?.user?.totpStatus ? (
        <section className={styles.TwoFactor_container}>
          <header>
            <div className={styles.back_btn}>
              <img
                src={ArrowBackIcon}
                alt="BACK"
                width={13}
                height={13}
                onClick={() => replace("/my-profile/info")}
              />
            </div>
            <div className={styles.title_of_2fa}>
              فعال سازی کد شناسایی دو عاملی
            </div>
          </header>
          <main>
            {step2fa === "1" ? (
              <DownloadGoogleAuth />
            ) : step2fa === "2" ? (
              <AppAuthCode twoFaCode={twoFaCode} setTwoFaCode={setTwoFaCode} />
            ) : step2fa === "3" ? (
              <TakeAuthCodeFromUser history={history} />
            ) : (
              "RELOAD THE PAGE OR CONTACT SUPPORT"
            )}
          </main>
          <footer className={styles.steps_of_verify}>
            <div
              className={`${step2fa === "1" ? styles.active_step : ""}`}
              onClick={() => setStep2fa("1")}
            >
              دانلود
            </div>
            <div
              className={`${step2fa === "2" ? styles.active_step : ""}`}
              onClick={() => setStep2fa("2")}
            >
              اسکن
            </div>
            <div
              className={`${step2fa === "3" ? styles.active_step : ""}`}
              onClick={() => setStep2fa("3")}
            >
              تایید
            </div>
          </footer>
        </section>
      ) : (
        <div className={styles.twoFAEnabled}>
          کد شناسایی دو عاملی شما فعال است
        </div>
      )}
    </>
  );
}
